/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

if (!customElements.get('product-usp')) {
  class ProductUsp extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('[data-usp-trigger]');
      this._content = this.querySelector('[data-usp-content]');
      this._close = this.querySelector('[data-usp-close]');

      this._trigger?.addEventListener('click', () => this._open());
      this._close?.addEventListener('click', (e) => {
        e.stopPropagation();
        this._hide();
      });
      this._content?.addEventListener('click', (e) => {
        if (!e.target.closest('[data-usp-prevent-click]')) {
          this._hide();
        }
      });
    }

    _open() {
      this._content?.removeAttribute('hidden');
    }

    _hide() {
      this._content?.setAttribute('hidden', '');
    }
  }
  customElements.define('product-usp', ProductUsp);
}

if (!customElements.get('product-usps')) {
  customElements.define('product-usps', class extends HTMLElement {});
}
